<div v-once class="grid__tile col-xs-2 col-sm-4 col-md-5">
    <div class="tile fadeOut">
        <div class="tile__information">
            <div class="tile__information--nickname"></div>
            <div class="tile__information--status"><span class="status offline"></span></div>
        </div>
        <div class="tile__block">
            <div class="tile__block--hearth"></div>
            <div class="tile__block--image">
                <Spinner/>
            </div>
            <span class="tile__block--advert"></span>
        </div>
    </div>
</div>
